import { Page } from "@/models/page-models/Page";

export const FgTransfer: Page = {
  "path": "fg-transfer",
  "name": "FG Transfer",
  "props": {
    "data": {
      "title": "FG Transfer",
      "printable": "FALSE",
      "url": "fg-transfer",
      "groups": [
        {
          "type": "tabs",
          "tabItems": [
            {
              "tabName": "FG",
              "bracketValueFormula": "fn(LENGTH,{{fetchedData.FG}})",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "variable": "formData.fgTable",
                      "label": "FG",
                      "disabled": "FALSE",
                      "items": "fetchedData.FG",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Good#"
                        },
                        {
                          "value": "__item.factoryTicket.order.customer.name",
                          "text": "Customer",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.factoryTicket.order.customer}})"
                        },
                        {
                          "value": "factoryTicket.order._id",
                          "text": "Order #"
                        },
                        {
                          "value": "__item.factoryTicket.order.product",
                          "text": "Product Description",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.factoryTicket.order.product}})"
                        },
                        {
                          "value": "__item.location.Factory.totalQuantity",
                          "text": "Floor Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,kgToSellingUnitQuantity,{{__item.factoryTicket.order}},{{__item}},{{__item.location.Factory.totalQuantity}})"
                        },
                        {
                          "value": "__item.factoryTicket.order.product.unit.unit2",
                          "text": "Selling Unit"
                        },
                        {
                          "value": "__item.packingDetails",
                          "text": "Packing Details",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,packingDetails,{{__item.factoryTicket.order}},{{__item}},{{__item.location.Factory.totalQuantity}})"
                        },
                        {
                          "value": "__item.actions",
                          "text": "Actions",
                          "type": "actions",
                          "width": 225,
                          "actions": [
                            {
                              "label": "Request Transfer",
                              "priority": "main",
                              "onClick": [
                                {
                                  "executionOrder": 1,
                                  "name": "copyFGId"
                                },
                                {
                                  "executionOrder": 1,
                                  "name": "copySelectedGoodsObject"
                                },
                                {
                                  "executionOrder": 1,
                                  "name": "copyLocationData"
                                },
                                {
                                  "executionOrder": 1,
                                  "name": "copySellingUnitArray"
                                },
                                {
                                  "executionOrder": 1,
                                  "name": "resetFgQuantity"
                                },
                                {
                                  "executionOrder": 2,
                                  "name": "copyDefaultFGFormValues"
                                },
                                {
                                  "executionOrder": 3,
                                  "name": "openFGTransferPopup"
                                }
                              ]
                            },
                            {
                              "label": "Go To Factory Ticket",
                              "priority": "menu",
                              "onClick": [
                                {
                                  "executionOrder": 1,
                                  "name": "openFactoryTicket"
                                }
                              ]
                            }
                          ],
                          "useMenu": true
                        }
                      ],
                      "tableType": "static",
                      "showActions": true,
                      "height": "73vh"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Request FG Transfer",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.locationFrom",
                  "label": "Location From",
                  "disabled": "TRUE",
                  "items": "fetchedData.location.locations",
                  "itemText": "_key",
                  "itemValue": "_key"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.locationTo",
                  "label": "Location To",
                  "disabled": "TRUE",
                  "items": "fetchedData.location.locations",
                  "itemText": "_key",
                  "itemValue": "_key"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.unitOfTransfer",
                  "label": "Unit of Transfer",
                  "disabled": "TRUE",
                  "items": "fetchedData.sellingUnits.options"
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "fetchedData.availableQuantity",
                  "label": "Available Quantity",
                  "showIf": "{{fetchedData.unitOfTransfer}}",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,kgToSellingUnitQuantity,{{fetchedData.selectedGood.factoryTicket.order}},{{fetchedData.selectedGood}},{{fetchedData.selectedGood.location.Factory.totalQuantity}},{{fetchedData.unitOfTransfer}})",
                  "filterType": "unit",
                  "filterParam": "{{fetchedData.unitOfTransfer}}"
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.quantity",
                  "label": "Enter Quantity",
                  "unit": "{{fetchedData.unitOfTransfer}}",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Submit",
              "onClick": [
                {
                  "executionOrder": 1,
                  "name": "copyResolvedFormData"
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "submitGoodsTransferRequest",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/goods/transfer/request",
                    "arg2Key": "postData",
                    "arg2Value": "formData",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE"
                  },
                  "name": "submitGoodsTransferRequest"
                },
                {
                  "executionOrder": 3,
                  "pageFunction": {
                    "name": "closeFGTransferPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Request FG Transfer"
                  },
                  "name": "closeFGTransferPopup"
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "getGoods"
      }
    ],
    "functions": [
      {
        "name": "closeFGTransferPopup",
        "type": "fnClosePopup",
        "arg1Key": "popupName",
        "arg1Value": "Request FG Transfer"
      },
      {
        "name": "submitGoodsTransferRequest",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/goods/transfer/request",
        "arg2Key": "postData",
        "arg2Value": "formData",
        "arg3Key": "refreshPage",
        "arg3Value": "TRUE"
      },
      {
        "name": "copyResolvedFormData",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getResolvedFormData",
        "arg2Key": "destinationKey",
        "arg2Value": "formData",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object",
        "arg4Key": "append",
        "arg4Value": "TRUE"
      },
      {
        "name": "getResolvedFormData",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "rawMaterial": "{{fetchedData.rawMaterial}}",
          "unitOfTransfer": "{{fetchedData.unitOfTransfer}}",
          "locationTo": "{{fetchedData.locationTo}}",
          "locationFrom": "{{fetchedData.locationFrom}}",
          "quantity": "fn(HELPER_FN,sellingUnitQuantityToKg,{{fetchedData.selectedGood}},{{fetchedData.quantity}},{{fetchedData.unitOfTransfer}},{{fetchedData.selectedGood.location.Factory.totalQuantity}})"
        },
        "useFormula": true
      },
      {
        "name": "openFGTransferPopup",
        "type": "fnOpenPopup",
        "arg1Key": "popupName",
        "arg1Value": "Request FG Transfer"
      },
      {
        "name": "copyDefaultFGFormValues",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getDefaultFormValues",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object",
        "arg4Key": "append",
        "arg4Value": "TRUE"
      },
      {
        "name": "getDefaultFormValues",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "unitOfTransfer": "{{fetchedData.sellingUnits.options.0}}",
          "locationTo": "Warehouse",
          "locationFrom": "Factory"
        },
        "useFormula": true
      },
      {
        "name": "resetFgQuantity",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.quantity"
      },
      {
        "name": "copySellingUnitArray",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__selectedObject",
        "arg2Key": "sourceFn",
        "arg2Value": "getSellingUnitArray",
        "arg3Key": "destinationKey",
        "arg3Value": "fetchedData.sellingUnits"
      },
      {
        "name": "getSellingUnitArray",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "options": "fn(HELPER_FN,availableSellingUnits,{{__selectedObject.factoryTicket.order.product.packingMode}})"
        },
        "useFormula": true
      },
      {
        "name": "copyLocationData",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__item.location",
        "arg2Key": "sourceFn",
        "arg2Value": "getLocationsArray",
        "arg3Key": "destinationKey",
        "arg3Value": "fetchedData.location"
      },
      {
        "name": "getLocationsArray",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "locations": "fn(TO_ARRAY,{{__selectedObject}})"
        },
        "useFormula": true
      },
      {
        "name": "copySelectedGoodsObject",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__item",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedGood"
      },
      {
        "name": "copyFGId",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__item._id",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.rawMaterial"
      },
      {
        "name": "openFactoryTicket",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "/factory-ticket/{{__item.factoryTicket._id}}"
      },
      {
        "name": "getGoods",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/goods/fg",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.goods",
        "arg3Key": "fnsAfterSubmit",
        "arg3Value": "[{\"name\":\"getFGs\",\"executionOrder\":1}]",
        "arg4Key": "addToState",
        "arg4Value": "{\"actionName\":\"addMultipleGoods\",\"variable\":\"fetchedData.goods.data\"}"
      },
      {
        "name": "filterFGs",
        "type": "fnFilterArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.goods.data",
        "arg2Key": "formulaCondition",
        "arg2Value": "fn(LOGICAL,{{__item.location.Factory.totalQuantity}},>,0.01)"
      },
      {
        "name": "getFGs",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "filterFGs",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.FG"
      }
    ]
  },
  "forRole": "PRODUCTION_MANAGER,PRODUCTION_PLANNER",
  "visible": true,
  "routerPriority": 80
}